import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import DatePicker from 'antd/lib/date-picker';
import Form from 'antd/lib/form';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Select from 'antd/lib/select';
import Tooltip from 'antd/lib/tooltip';
import moment from 'moment';
import * as React from 'react';
import injectSheet from 'react-jss';
import {
  computeDeadlineDependentTasksV2,
  createShipmentTask,
  editShipmentTask,
  getResponsibileOrgsForShipment,
} from 'src/api/shipmentExecution';
import { fetchAllUsersOfOrg } from 'src/api/users';
import { validateEmail } from 'src/utils/utils';
import SESelectTeams from '../../../SECommon/SESelectTeams';

import TagsInput from 'src/components/common/TagsInput';
import { SETask } from 'src/dto/response/fetchShipmentTasks';
import { StylesProps } from 'src/Library/Types';
import { UpdateTaskApiObject } from '../../../SE.interfaces';
import SETaskRevisionModalV2 from './../SETaskRevisionModalV2';

function getVariableStyle() {
  const obj = {
    Not_Started: '#FFFFFF',
    In_Progress: '#FFF1B8',
    Done: '#95DE64',
    Cancelled: '#DEDEDE',
  };
  const getBase = (color) => {
    return {
      '& .ant-select-selection--single': {
        backgroundColor: color,
      },
    };
  };
  const result = {};
  for (const i in obj) {
    result[`select-${i}`] = getBase(obj[i]);
  }
  return result;
}
const styles = (theme) => ({
  modal: {
    minWidth: 442,
    '& .ant-modal-header': {
      height: 48,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 16,
    },
    '& .ant-modal-footer': {
      height: 48,
    },
  },
  title: {
    fontSize: 14,
    color: '#111111',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  cross: {
    cursor: 'pointer',
    marginRight: 10,
  },
  ...getVariableStyle(),
});

interface SEAddTaskModalProps extends StylesProps<ReturnType<typeof styles>> {
  isEdit: boolean;
  visible: boolean;
  data: SETask;
  sourceObjectId: string;
  handleClose: () => void;
  handleSubmit: () => Promise<void>;
}
interface StateProps extends Record<string, any> {
  apiCallObject?: UpdateTaskApiObject;
}
class SEAddTaskModal extends React.PureComponent<SEAddTaskModalProps, StateProps> {
  state: StateProps = {
    isCreating: false,
    taskType: undefined,
    taskTypeInput: undefined,
    isTaskInputVisible: false,
    responsibleOrg: undefined,
    responsibleUser: undefined,
    deadline: undefined,
    deadlineTime: undefined,
    isDefaultDeadlineSet: false,
    status: undefined,
    responsibleOrgOptions: [],
    responsibleUserOptions: [],
    selectedTeam: undefined,
    selectedTeamName: undefined,
    isLoading: false,
    emails: [],
    detailsPlaceholder: undefined,
    isSETaskRevisionModalVisible: false,
    taskRevisionModalData: [],
  };

  componentDidMount = async () => {
    const { isEdit, data, sourceObjectId } = this.props;
    this.setState({
      isLoading: true,
    });
    const params = { shipmentId: sourceObjectId };
    const params2 = { shipmentId: sourceObjectId };
    // TODO add dto type params2: typeof ApiDto.GetTaskResponsibleOrganisationMasterDto
    // absent in swagger.ts
    const response2 = await getResponsibileOrgsForShipment(params2);
    if (response2.isSuccess) {
      this.setState({ responsibleOrgOptions: response2.data });
    }
    if (isEdit) {
      if (data.responsibleOrganisationId) {
        await this.handleResponsibleOrgChange(data.responsibleOrganisationId);
      }
      this.setState(
        {
          taskType: data.name,
          responsibleOrg: data.responsibleOrganisationId
            ? data.responsibleOrganisationId
            : undefined,
          responsibleUser: data.responsibleUserId ? data.responsibleUserId : undefined,
          deadline: data.deadline ? moment(data.deadline) : undefined,
          deadlineTime: data.deadline ? moment(data.deadline) : undefined,
          status: data.status,
          detail: data.remark,
          emails: data.watcherList,
          selectedTeam: data.responsibleTeamId || undefined,
          selectedTeamName: data.responsibleTeamName || undefined,
        },
        () => {
          const apiCallObject = this.createApiCallObject() || {};
          this.setState({
            apiCallObject,
            isLoading: false,
          });
        }
      );
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleResponsibleOrgChange = async (orgId, userId = undefined) => {
    this.setState({ responsibleOrg: orgId });
    if (!orgId) {
      this.setState({
        responsibleUserOptions: [],
        selectedTeam: undefined,
        selectedTeamName: undefined,
        responsibleUser: undefined,
      });
      return;
    }
    const response = await fetchAllUsersOfOrg({ organisationId: orgId });
    if (response.isSuccess) {
      this.setState({
        responsibleUserOptions: response.data,
        selectedTeam: undefined,
        selectedTeamName: undefined,
        responsibleUser: userId && String(userId),
      });
    }
  }

  changeUserOptions = (users) => {
    this.setState({ responsibleUserOptions: users });
  }

  handleEmailChange = (emails: string[]) => {
    const validatedEmails: string[] = [];
    emails.forEach((email: string) => {
      if (validateEmail(email)) {
        validatedEmails.push(email);
      } else {
        message.error(`${email} is not a valid email. Please provide a valid email.`);
      }
    });
    this.setState({ emails: validatedEmails });
  }

  confirmDependentTasks = async () => {
    if (!this.props.isEdit) {
      this.handleAddTask({});
      return;
    }

    const newDeadline: any = this.state.deadline;
    const oldDeadline = this.state?.apiCallObject?.deadline;
    if (newDeadline?.isSame(oldDeadline)) {
      this.handleAddTask({});
      return;
    }

    const response: any = await computeDeadlineDependentTasksV2(
      {
        shipmentId: this.props.sourceObjectId,
      },
      {
        taskId: this.props.data.id,
        deadline: this.state.deadline ? moment(this.state.deadline).utc().valueOf() : null,
      }
    );

    if (response.isSuccess) {
      const dependentTasks = response.data;
      if (dependentTasks?.length) {
        this.setState({
          taskRevisionModalData: dependentTasks,
          isSETaskRevisionModalVisible: true,
        });
        return;
      }
      this.handleAddTask({});
    } else {
      message.error(response.errorMessage);
    }
  };

  createApiCallObject = () => {
    const {
      taskType,
      responsibleOrg,
      responsibleUser,
      deadline,
      status,
      taskTypeInput,
      selectedTeam,
      emails,
    } = this.state;
    const body: any = {};
    message.config({ top: 100, duration: 2 });
    if (taskType === null || taskType === undefined) {
      message.error('Task Name Cannot Be Empty');
      return;
    }
    if (!responsibleOrg) {
      message.error('Org Assignee Cannot Be Empty');
      return;
    }
    body.responsibleOrganisationId = responsibleOrg;
    body.responsibleUserId = responsibleUser || null;
    body.name = taskTypeInput ? taskTypeInput : taskType;
    status ? (body.status = status) : null;
    body.deadline = deadline ? moment(deadline).utc().valueOf() : null;
    body.responsibleTeamId = selectedTeam ? selectedTeam : null;
    body.milestone = this.props.data?.milestone;
    body.watcherList = emails;
    return body;
  };

  handleAddTask = async (dependentTasksToUpdate) => {
    const apiCallObject: any = this.createApiCallObject();
    if (!apiCallObject) return;

    if (dependentTasksToUpdate?.length) {
      apiCallObject.dependentTaskIds = dependentTasksToUpdate;
    }

    this.setState({ isCreating: true });

    let response;
    if (!this.props.isEdit) {
      const createTaskParams = {
        shipmentId: this.props.sourceObjectId,
      };
      response = await createShipmentTask(createTaskParams, apiCallObject);
    } else {
      const editTaskParams = {
        shipmentId: this.props.sourceObjectId,
        taskId: this.props.data.id,
      };
      response = await editShipmentTask(editTaskParams, apiCallObject);
    }
    this.setState({ isCreating: false });
    if (response.isSuccess) {
      await this.props.handleSubmit();
    } else {
      message.error(response.errorMessage);
    }
  };

  suggestDeadlineHours = (newDeadline) => {
    const defaultHours = 17;
    return newDeadline?.isSame(this.state.deadline, 'day')
      ? newDeadline
      : newDeadline?.startOf('day').add(defaultHours, 'hours');
  };
  
  renderLine = () => {
    return (
      <div style={{
        display: 'flex',
        height: 1,
        backgroundColor: '#CCCCCC',
        margin: '12px 0px',
      }} />
    );
  };

  renderTitle = () => {
    const { isEdit, classes } = this.props;
    return (
      <div className={classes.title}>
        <span className={classes.cross} onClick={this.props.handleClose}>&#10005;</span>
        {isEdit ? 'Edit' : 'Add'} Task
      </div>
    );
  }

  render() {
    const {
      isEdit,
      classes,
    } = this.props;

    const {
      taskTypeOptions,
      responsibleOrgOptions,
      responsibleUserOptions,
      isSETaskRevisionModalVisible,
      taskRevisionModalData,
    } = this.state;

    return (
      <Modal
        className={classes.modal}
        style={{ position: 'absolute', right: 16 }}
        width={442}
        visible={this.props.visible && !isSETaskRevisionModalVisible}
        okText="Update"
        onOk={this.confirmDependentTasks}
        title={this.renderTitle()}
        closable={false}
        onCancel={this.props.handleClose}
        footer={[
          <Button style={{ height: 27, border: 0 }} onClick={this.props.handleClose}>Cancel</Button>,
          <Button
            loading={this.state.isCreating}
            style={{ height: 27, background: '#006EC3', color: '#FFFFFF' }}
            onClick={this.confirmDependentTasks}
          >Submit</Button>,
        ]}
      >
        <div>
          {isSETaskRevisionModalVisible && (
            <SETaskRevisionModalV2
              visible={isSETaskRevisionModalVisible}
              onSubmit={this.handleAddTask}
              onCancel={() => this.setState({ isSETaskRevisionModalVisible: false })}
              data={taskRevisionModalData}
            />
          )}
          <Form>
            <Row gutter={2}>
              <Col span={6}>
                <span style={{ lineHeight: 3, color: '#111111', fontWeight: 600, fontSize: 12 }}>Task Name*</span>
              </Col>
              <Col span={18}>
                <span>
                  <Form.Item style={{ margin: 0 }} required={true}>
                    <Tooltip title={this.state.taskType}>
                      <div>
                        <Input
                          placeholder="Enter Task Name"
                          autoFocus
                          allowClear
                          style={{ width: '100%' }}
                          value={this.state.taskType}
                          onChange={e => this.setState({ taskType: e.target.value })}
                        />
                      </div>
                    </Tooltip>
                  </Form.Item>
                </span>
              </Col>
              <Col span={6} />
              <Col span={12}>
                <Row gutter={2} style={{ marginTop: '5px' }}>
                  <span style={{ lineHeight: 2.5, color: '#111111', fontWeight: 600, fontSize: 12 }}>Deadline</span>
                  <span>
                    <DatePicker
                      placeholder="Deadline"
                      value={this.state.deadline}
                      showTime
                      style={{ width: '100%' }}
                      format={'DD MMM YYYY | hh:mm A'}
                      disabledDate={(current) => {
                        return !!current && current < moment();
                      }}
                      onChange={(val) =>
                        this.setState({
                          deadline: this.suggestDeadlineHours(val),
                        })
                      }
                    ></DatePicker>
                  </span>
                </Row>
              </Col>
              <Col span={6}>
                {isEdit ? (
                <Row gutter={2} style={{ marginTop: 5, marginLeft: 8 }}>
                  <span style={ { lineHeight: 2.5, color: '#111111', fontWeight: 600, fontSize: 12 }}>Status</span>
                  <span>
                    <Select
                      className={`${
                        this.state.status === 'Not Started'
                          ? this.props.classes['select-Not_Started']
                          : this.state.status === 'In Progress'
                            ? this.props.classes['select-In_Progress']
                            : this.props.classes[`select-${this.state.status}`]
                        }`}
                      value={this.state.status}
                      style={{ width: '100%' }}
                      onChange={(val) => this.setState({ status: val })}
                    >
                      <Select.Option
                        style={{ backgroundColor: '#FFF1B8' }}
                        key="In Progress"
                        data-value="In Progress"
                      >
                        In Progress
                      </Select.Option>
                      <Select.Option
                        style={{ backgroundColor: '#95DE64' }}
                        key="Done"
                        data-value="Done"
                      >
                        Done
                      </Select.Option>
                      <Select.Option
                        style={{ backgroundColor: '#DEDEDE' }}
                        key="Cancelled"
                        data-value="Cancelled"
                      >
                        Cancelled
                      </Select.Option>
                    </Select>
                  </span>
                </Row>
              ) : null}
              </Col>
            </Row>
            {this.renderLine()}
            <Row gutter={2} style={{ marginTop: '5px' }}>
              <Col span={6}>
                <span style={{ lineHeight: 3, color: '#111111', fontWeight: 600, fontSize: 12 }}>Org Assignee*</span>
              </Col>
              <Col span={18}>
                <span>
                  <Form.Item style={{ margin: 0 }} required={true}>
                    <Select
                      placeholder="Select Organisation"
                      autoFocus={isEdit}
                      showSearch
                      allowClear
                      style={{ width: '100%' }}
                      value={this.state.responsibleOrg}
                      filterOption={(input, option: any) => {
                        return (
                          option.props.children &&
                          option.props.children.toLowerCase().includes(input.toLowerCase())
                        );
                      }}
                      onChange={(orgId) => this.handleResponsibleOrgChange(orgId)}
                    >
                      {responsibleOrgOptions.map((item) => {
                        return <Select.Option key={item.id}>{item.name}</Select.Option>;
                      })}
                    </Select>
                  </Form.Item>
                </span>
              </Col>
            </Row>
            <Row gutter={2} style={{ marginTop: '5px' }}>
              <Col span={6}>
                <span style={{ lineHeight: 3, color: '#111111', fontWeight: 600, fontSize: 12 }}>
                  Team Assignee
                </span>
              </Col>
              <Col span={18}>
                <span>
                  <Form.Item style={{ margin: 0 }} required={true}>
                    <SESelectTeams
                      disabled={this.state.responsibleOrg !== window.localStorage.getItem('organisationId')}
                      changeUserOptions={this.changeUserOptions}
                      value={this.state.selectedTeam}
                      selectedTeamName={this.state.selectedTeamName}
                      onChange={(val) => {
                        this.setState({ selectedTeam: val, responsibleUser: undefined });
                        !val && this.setState({ selectedTeamName: undefined });
                      }}
                    />
                  </Form.Item>
                </span>
              </Col>
            </Row>
            <Row gutter={2} style={{ marginTop: '5px' }}>
              <Col span={6}>
                <span style={{ lineHeight: 3, color: '#111111', fontWeight: 600, fontSize: 12 }}>User Assignee</span>
              </Col>
              <Col span={18}>
                <span>
                  <Form.Item style={{ margin: 0 }}>
                    <Select
                      placeholder="Select User"
                      autoFocus={isEdit}
                      showSearch
                      allowClear
                      style={{ width: '100%' }}
                      disabled={this.state.responsibleOrg !== window.localStorage.getItem('organisationId')}
                      value={this.state.responsibleUser}
                      filterOption={(input, option: any) => {
                        return (
                          option.props.children &&
                          option.props.children.toLowerCase().includes(input.toLowerCase())
                        );
                      }}
                      onChange={(val) => this.setState({ responsibleUser: val })}
                    >
                      {responsibleUserOptions.map((item: any) => {
                        return (
                          item.name && <Select.Option key={item.id}>{item.name}</Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </span>
              </Col>
            </Row>
            {this.renderLine()}
            <Row gutter={2} style={{ marginTop: '5px' }}>
              <Col span={6}>
                <span style={{ lineHeight: 3, color: '#111111', fontWeight: 600, fontSize: 12 }}>Watcher (s)
                <Tooltip title="Add e-mail IDs of users to let them get updates for this task"> <Icon type="question-circle" theme="filled" /></Tooltip>
                </span>
              </Col>
              <Col span={18}>
                <span>
                  <Form.Item style={{ margin: 0, height: 28 }}>
                    <TagsInput
                      style={{ width: '100%' }}
                      autoFocus={true}
                      value={this.state.emails}
                      placeholder={'Write e-mail IDs to add watcher (s)'}
                      notFoundContent={''}
                      onChange={this.handleEmailChange}
                      tokenSeparators={[' ']}
                    />
                  </Form.Item>
                  <span style={{
                    color: '#333333',
                    fontFamily: "Open Sans",
                    fontSize: 8,
                    fontStyle: 'italic',
                    }}>Add e-mail IDs of users to let them get updates for this task.</span>
                </span>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
    );
  }
}

export default injectSheet(styles)(SEAddTaskModal);
